export default "__VITE_ASSET__BU7uOpt0__"